/**
 * For the content of a popover that opens from inside a sheet (the property list of the advanced
 * filters, the quick filters of the mobile sheet): the sheet is a modal, whose scroll lock cancels
 * wheel and touch events from outside its own DOM, and the popover is portaled to <body>. Stopping
 * them at the popover keeps its list scrollable (as in OrganisationCombobox).
 */
export const keepScrolling = (event: { stopPropagation: () => void }) => event.stopPropagation()
